<template>
    <div id="app">
        <div class="wod-container">
            <header>
                <img src='./assets/wod-of-death-logo.png'>
            </header>

            <div>
                <p v-html="messages.welcome"></p>

                <button type="submit"
                        @click.prevent="displayNewWod()"
                        :disabled="timelineStarted"
                        class="wod-button">
                    {{claim}}
                </button>
            </div>

            <pre v-if="false" style="font-family: monospace; text-align:left; font-size: 10px;">{{ workoutDisplay }}</pre>


            <div class="wod" v-show="workoutDisplay">
                <div style="margin: auto; justify-content: space-around; display: flex;
    padding: 30px;
max-width: 600px; transition: all .5s">
                    <div style=" min-width: 250px;">
                        <div id="list-complete-demo" class="demo" style="font-size: 15px;">

                            <transition-group name="card" tag="div">
                                <div class="card"
                                     v-for="(label, key) in workoutDisplay"
                                     :key="key"
                                     v-html="label"></div>
                            </transition-group>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Flames :shown="showFlames"></Flames>

        <AudioElement
                :play="playAudio"
                :sourceFile="audioPath"
                :audioStartPosition="audioStartPosition"
                :fadeIn="true"
                :fadeOut="true"
                :fadeMilliseconds="2000"
                :loopStart="0.05"
                :loopEnd="24"
                :loop="true"></AudioElement>
    </div>
</template>

<script>
    import Vue from "vue";
    import Flames from "./components/Flames";
    import AudioElement from './components/AudioElement';
    import WOD_MESSAGES from './shared/messages';
    import WOD_COMBINATIONS from './shared/wod-combinations';
    import WOD_CALCULATOR from './shared/wod-calculations';
    import WOD_DIFFICULTY_LEVELS from './shared/wod-difficulty-grades';

    const userLang = navigator.language || navigator.userLanguage;

    const wodMessages = WOD_MESSAGES[userLang] || WOD_MESSAGES['en-EN'];
    const wodCombinations = WOD_COMBINATIONS;

    const wodCalculator = WOD_CALCULATOR(WOD_COMBINATIONS, WOD_DIFFICULTY_LEVELS);

    // Audio setup
    const audioPath = require("./assets/wod-sound.mp3");
    const audio = new Audio(audioPath);
    audio.loop = true;

    export default {
        name: "app",
        components: {
            Flames,
            AudioElement
        },
        data() {
            return {
                messages: wodMessages,
                wodCalculator: wodCalculator,
                workoutDisplay: [],
                timelineStarted: false,
                finished: '',
                playAudio: false,
                audioPath: audioPath,
                animationInterval: 0,
                firstIteration: true,
                animationActive: false,
                showFlames: false,
                audioStartPosition: 0,
                wodCombinations: wodCombinations,
                animationTimeouts: [],
                wodSession: {
                    rounds: 0,
                    exercises: [],
                    difficultyLevel: null,
                    labelsToPrint: [],
                },
                claim: wodMessages.give_it_to_me
            }
        },
        computed: {
        },
        methods: {
            displayNewWod() {
                const vm = this;

                vm.firstIteration = false;
                vm.workoutDisplay = [];

                const workout = this.wodCalculator.getRandomWorkout();
                vm.generateTimeline(workout);
                vm.timelineStarted = true;
                vm.wodSession.forEach((item) => {
                    setTimeout(() => {
                        item.callback(vm);
                    }, item.timing)
                });
            },
            generateTimeline(workout) {
                const timeline = [];
                const vm = this;

                // Exercises
                let time = 0;
                timeline.push({
                    timing: time,
                    callback: (vm) => {
                        vm.playAudio = true;
                    }
                });
                workout.exercises.forEach(item => {
                    time += 1000;
                    timeline.push({
                        timing: time,
                        callback: (vm) => {
                            const label = vm.generateLabelForExercise(item);
                            vm.workoutDisplay.push(label);
                        }
                    })
                });

                // Rounds
                time += 1000;
                timeline.push({
                    timing: time,
                    callback: (vm) => {
                        const label = vm.generateLabelForRounds(workout.rounds);
                        vm.workoutDisplay.push(label);
                    }
                });

                // Flames
                time += 1000;
                timeline.push({
                    timing: time,
                    callback: (vm) => {
                        vm.showFlames = true;
                    }
                });

                // Difficulty
                time += 500;
                timeline.push({
                    timing: time,
                    callback: (vm) => {
                        const label = vm.generateLabelForDifficulty(workout.difficulty);
                        vm.workoutDisplay.push(label);
                    }
                });

                // Difficulty
                time += 4000;
                timeline.push({
                    timing: time,
                    callback: (vm) => {
                        vm.playAudio = false;
                        vm.showFlames = false;
                        vm.claim = this.messages.give_me_another_one;
                        vm.timelineStarted = false;
                    }
                });

                this.wodSession = timeline;
            },
            youtubeExerciseLink(exerciseName) {
                exerciseName = exerciseName.toLowerCase();
                exerciseName = encodeURI(exerciseName);
                return 'https://www.youtube.com/results?search_query=crossfit+' + exerciseName;
            },
            generateLabelForExercise(item) {
                return '' +
                    '<strong style="color:#DD0000; font-size: 120%;">' + item.rounds + 'X</strong> ' +
                    '<a href="' + this.youtubeExerciseLink(item.name) + '" target="_blank" rel="nopener noreferrer">' + item.name + '</a>'
            },
            generateLabelForRounds(rounds) {
                return '' +
                    '<span style="font-size: 200%;">' +
                    '' + this.messages.repeat + ' ' +
                    '<strong style="color:#DD0000; font-size: 120%;">' +
                    '' + rounds + 'X' +
                    '</strong>' +
                    '</span>'
            },
            generateLabelForDifficulty(difficultyLevel) {
                return '' +
                    '<span style="font-size: 200%;">' +
                    '  <strong style="color: ' + difficultyLevel.color + '; font-size: 120%;">' +
                    '  ' + this.messages.labels[difficultyLevel.code] + '' +
                    '  </strong>' +
                    '</span>';
            },
            randomInt(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        }
    };
</script>

<style lang="scss">
    body {
        background: #111;
        color: #ddd;
    }

    #app {
        max-width: 900px;
        margin: auto;
        font-family: "Metal Mania", sans-serif;
        font-size: 25px;
        letter-spacing: 5px;
        text-align: center;
        text-transform: lowercase;
        p {
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }

    a {
        color: white;
    }

    input,
    button {
        font-family: "Metal Mania", sans-serif;
    }

    .wod-container {
        position: relative;
        z-index: 1;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 1;
    }

    .wod-button[disabled] {
        background: #333;
        color: #111;
    }

    .wod-button {
        cursor: pointer;
        transition: all .5s;
        font-size: 20px;
        padding: 20px;
        background: rgba(247, 215, 52, 1);
        background: -moz-linear-gradient(
                        top,
                        rgba(247, 215, 52, 1) 0%,
                        rgba(231, 56, 39, 1) 100%
        );
        background: -webkit-gradient(
                        left top,
                        left bottom,
                        color-stop(0%, rgba(247, 215, 52, 1)),
                        color-stop(100%, rgba(231, 56, 39, 1))
        );
        background: -webkit-linear-gradient(
                        top,
                        rgba(247, 215, 52, 1) 0%,
                        rgba(231, 56, 39, 1) 100%
        );
        background: -o-linear-gradient(
                        top,
                        rgba(247, 215, 52, 1) 0%,
                        rgba(231, 56, 39, 1) 100%
        );
        background: -ms-linear-gradient(
                        top,
                        rgba(247, 215, 52, 1) 0%,
                        rgba(231, 56, 39, 1) 100%
        );
        background: linear-gradient(
                        to bottom,
                        rgba(247, 215, 52, 1) 0%,
                        rgba(231, 56, 39, 1) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient(
                        startColorstr="#f7d734",
                        endColorstr="#e73827",
                        GradientType=0
        );
    }

    header {
        margin: auto;
        img {
            width: 100%;
        }
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
            padding: 0;
            margin: 0;
        }
    }

    .card {
        transition: all 0.5s;
    }

    .card-enter,
    .card-leave-to {
        opacity: 0;
    }

    .card-enter-to {
        opacity: 1;
        transform: scale(1);
    }

    .card-leave-active {
        /*position: absolute;*/
    }

    .card-move {
        opacity: 1;
        transition: all 0.5s;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue